import type { TemplateStep } from './templateDefinition.types';

/**
 * Freezes the Mandatory switch of every system field the kind declares mandatory (2026-10-21): the switch shows on
 * and disabled, and a stored or sent "optional" is overruled. Unlike the BID template's lock the field stays editable
 * otherwise -- its title and helper text can still change. The optional ones, and custom fields, stay switchable.
 */
export const freezeMandatorySystemFields = (steps: TemplateStep[]): TemplateStep[] =>
  steps.map((step) => ({
    ...step,
    fields: step.fields.map((field) =>
      field.mandatory && field.isHeader !== true ? { ...field, mandatoryLocked: true } : field,
    ),
  }));
